define('constants/contactAddressCountryLabelEnumerations',[], function () {
    return  {
        US: 1,
        CA: 2,
        Other: 3,
    };
});
